const projects = [
    {
        title: "Flight Telemetry Platform",
        description: "Flight telemetry and monitoring platform built with FastAPI and PostgreSQL, featuring real-time telemetry ingestion, alerting, and fault simulation.",
        tech: ["Python", "FastAPI", "React", "PostgreSQL", "Docker"],
        github: "https://github.com/RoleyRoley/flight-telemetry-platform",
    },
    {
        title: "Video Game Price Tracker",
        description: "A web application for tracking game prices on various sites over time. Search for games, add them to your watchlist, and monitor price changes - including discounts - with an automatically updating price history.",
        tech: ["Python", "FastAPI"],
        github: "https://github.com/RoleyRoley/video_game_price_tracker",
    },
    {
        title: "Sorting Visualizer",
        description: "A visual representation of various sorting algorithms, built using Python.",
        tech: ["Python"],
        github: "https://github.com/RoleyRoley/sorting_algorithm_visualiser",
    },
    {
        title: "Portfolio Website",
        description: "Repository for this website.",
        tech: ["React", "Tailwind CSS"],
        github: "https://github.com/RoleyRoley/my-portfolio",
    },
    {
        title: "Dog Grooming Website",
        description: "A responsive website in development for a local business.",
        tech: ["React", "Tailwind CSS"],
        github: "https://github.com/your-username/portfolio",
        demo: "https://www.thedogandcollar.uk" 
    },
    {
        title: "Credit Card Validator",
        description: "A Python project that checks the validity of a credit card number using Luhn's algorithm.",
        tech: ["Python"],
        github: "https://github.com/RoleyRoley/credit_card_validator",
    },
    
    
    

];


export default projects;